module.exports = {
  title: 'ivm',

  fixedHeader: false,

  sidebarLogo: true,
};
